import l1 from "../images/livePadBacks/livepadback1.png";
import l2 from "../images/livePadBacks/livepadback2.png";
import l3 from "../images/livePadBacks/livepadback3.png";
import l4 from "../images/livePadBacks/livepadback4.png";
import l5 from "../images/livePadBacks/livepadback5.png";
import l6 from "../images/livePadBacks/livepadback6.png";
import l7 from "../images/livePadBacks/livepadback7.png";
import l8 from "../images/livePadBacks/livepadback8.png";
import l9 from "../images/livePadBacks/livepadback9.png";
import l10 from "../images/livePadBacks/livepadback10.png";
import l11 from "../images/livePadBacks/livepadback11.png";
import l12 from "../images/livePadBacks/livepadback12.png";
import l13 from "../images/livePadBacks/livepadback13.png";
import l14 from "../images/livePadBacks/livepadback14.png";
import l15 from "../images/livePadBacks/livepadback15.png";
import l16 from "../images/livePadBacks/livepadback16.png";
import l17 from "../images/livePadBacks/livepadback17.png";
import l18 from "../images/livePadBacks/livepadback18.png";
import l19 from "../images/livePadBacks/livepadback19.png";
import l20 from "../images/livePadBacks/livepadback20.png";
import l21 from "../images/livePadBacks/livepadback21.png";
import l22 from "../images/livePadBacks/livepadback22.png";
import l23 from "../images/livePadBacks/livepadback23.png";
import l24 from "../images/livePadBacks/livepadback24.png";
import l25 from "../images/livePadBacks/livepadback25.png";
import l26 from "../images/livePadBacks/livepadback26.png";
import l27 from "../images/livePadBacks/livepadback27.png";
import l28 from "../images/livePadBacks/livepadback28.png";
import l29 from "../images/livePadBacks/livepadback29.png";
import l30 from "../images/livePadBacks/livepadback30.png";
import l31 from "../images/livePadBacks/livepadback31.png";
import l32 from "../images/livePadBacks/livepadback32.png";
import l33 from "../images/livePadBacks/livepadback33.png";
import l34 from "../images/livePadBacks/livepadback34.png";
import l35 from "../images/livePadBacks/livepadback35.png";
import l36 from "../images/livePadBacks/livepadback36.png";
import l37 from "../images/livePadBacks/livepadback37.png";
import l38 from "../images/livePadBacks/livepadback38.png";
import l39 from "../images/livePadBacks/livepadback39.png";
import l40 from "../images/livePadBacks/livepadback40.png";
import l41 from "../images/livePadBacks/livepadback41.png";
import l42 from "../images/livePadBacks/livepadback42.png";

const images = [
  { name: "l1", image: l1 },
  { name: "l2", image: l2 },
  { name: "l3", image: l3 },
  { name: "l4", image: l4 },
  { name: "l5", image: l5 },
  { name: "l6", image: l6 },
  { name: "l7", image: l7 },
  { name: "l8", image: l8 },
  { name: "l9", image: l9 },
  { name: "l10", image: l10 },
  { name: "l11", image: l11 },
  { name: "l12", image: l12 },
  { name: "l13", image: l13 },
  { name: "l14", image: l14 },
  { name: "l15", image: l15 },
  { name: "l16", image: l16 },
  { name: "l17", image: l17 },
  { name: "l18", image: l18 },
  { name: "l19", image: l19 },
  { name: "l20", image: l20 },
  { name: "l21", image: l21 },
  { name: "l22", image: l22 },
  { name: "l23", image: l23 },
  { name: "l24", image: l24 },
  { name: "l25", image: l25 },
  { name: "l26", image: l26 },
  { name: "l27", image: l27 },
  { name: "l28", image: l28 },
  { name: "l29", image: l29 },
  { name: "l30", image: l30 },
  { name: "l31", image: l31 },
  { name: "l32", image: l32 },
  { name: "l33", image: l33 },
  { name: "l34", image: l34 },
  { name: "l35", image: l35 },
  { name: "l36", image: l36 },
  { name: "l37", image: l37 },
  { name: "l38", image: l38 },
  { name: "l39", image: l39 },
  { name: "l40", image: l40 },
  { name: "l41", image: l41 },
  { name: "l42", image: l42 },
];

export default (name: string) => {
  return images.find((image) => image.name === name);
};
